import { hBuilding, iPhone, iUser } from '@hover/icons';
import React from 'react';

import { ContactConsentPolicyField } from 'src/modules/signUp/components/ContactConsentPolicyField';
import { TermsOfServiceField } from 'src/modules/signUp/components/TermsOfServiceField';
import { TextField } from 'src/shared/components/forms';
import type { ConsentPolicy, Maybe } from 'src/shared/graphql/generated';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import { BranchDropdownField } from '../BranchDropdownField';

interface FieldsProps {
  needsUserUpdate?: boolean;
  showBranchField?: boolean;
  contactPolicy?: Maybe<ConsentPolicy>;
}

const Fields = ({
  showBranchField = false,
  needsUserUpdate,
  contactPolicy,
}: FieldsProps) => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);

  return (
    <>
      <TextField
        iconBefore={iUser}
        isDisabled={needsUserUpdate}
        label={t('firstName')}
        name="givenName"
        placeholder={t('firstName')}
      />
      <TextField
        iconBefore={iUser}
        isDisabled={needsUserUpdate}
        label={t('lastName')}
        name="familyName"
        placeholder={t('lastName')}
      />
      <TextField
        iconBefore={hBuilding}
        isDisabled={needsUserUpdate}
        label={t('company')}
        name="company"
        placeholder={t('company')}
      />
      <TextField
        iconBefore={iPhone}
        label={t('mobilePhone')}
        name="mobilePhone"
        placeholder={t('mobilePhone')}
        type="tel"
      />
      {showBranchField && (
        <BranchDropdownField
          emptyText={t('beacon.startTypingToSearch')}
          label={t('beacon.homeBranch')}
          name="branch"
          placeholder={t('beacon.homeBranch')}
        />
      )}
      <TermsOfServiceField />
      {contactPolicy && <ContactConsentPolicyField policy={contactPolicy} />}
    </>
  );
};

export { Fields };
